import React from 'react';
import Typed from 'typed.js';
import { useEffect, useRef } from 'react';


export default function LiveFont() {
  // Create reference to store the DOM element containing the animation
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ['MERN stack Developer','Web Designer','App Developer','Full Stack Developer','Web App Developer'],
      typeSpeed: 80,
      loop: true, // Add this option to make it loop indefinitely
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

  return (
    <div className="App">
      <span ref={el} />
    </div>
  );
}